export default [{
  path: '/auth/signin',
  name: 'auth-signin',
  component: () => import(/* webpackChunkName: "auth-signin" */ '@/pages/auth/SigninPage.vue'),
  meta: {
    layout: 'auth',
    requiresAuth: false
  }
},
{
  path: '/error/not-found',
  name: 'error-not-found',
  component: () => import(/* webpackChunkName: "error-not-found" */ '@/pages/error/NotFoundPage.vue'),
  meta: {
    layout: 'error',
    requiresAuth: false
  }
},
{
  path: '/tools/filescloud',
  name: 'files-cloud',
  component: () => import('@/pages/Files/files.vue'),
  meta: { requiresAuth: true, moduleKey: 'files' }
},
{
  path: '/tools/shorturl',
  name: 'short-url',
  component: () => import('@/pages/Urls/url.vue'),
  meta: { requiresAuth: true, moduleKey: 'short_url' }
},
{
  path: '/tools/shorturl/detai',
  name: 'detail-short-url',
  component: () => import('@/pages/Urls/DetailUrl.vue'),
  meta: { requiresAuth: true, moduleKey: 'short_url' }
},
{
  path: '/tools/agendas',
  name: 'empty-agenda',
  component: () => import('@/pages/Agendas/agendaEmpty.vue'),
  meta: { requiresAuth: true, moduleKey: 'agendas' }
},
{
  path: '/tools/agendas/:agendaId?',
  name: 'contactos-agenda',
  component: () => import('@/pages/Agendas/agenda.vue'),
  meta: { requiresAuth: true, moduleKey: 'agendas' }
},
{
  path: '/tools/agendas/:agendaId/contacts',
  name: 'contacts',
  component: () => import('@/pages/Agendas/contacts.vue'),
  props: true,
  meta: { requiresAuth: true, moduleKey: 'agendas' }
},
{
  path: '/bots',
  name: 'bots',
  component: () => import('@/pages/bots/bots.vue'),
  meta: { requiresAuth: true, requiresServices: [5] }
},
{
  path: '/companies',
  name: 'companies',
  component: () => import('@/pages/Companies/Companies.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/channels/vendors',
  name: 'channels-vendors',
  component: () => import('@/pages/Channels/channels.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/channels/senders',
  name: 'channels-senders',
  component: () => import('@/pages/Channels/SendersManagement.vue'),
  meta: { requiresAuth: true, requiresServices: [3] }
},
{
  path: '/support/flows',
  name: 'support-flows',
  component: () => import('@/pages/Support/Flows/SupFlowsView.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/testing',
  name: 'testing',
  component: () => import('@/components/common/TestComponent.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/document/crear',
  name: 'documentacion-crear',
  component: () => import('@/pages/Documentacion/CrearDoc.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/document/crearotp',
  name: 'documentacion-crear-otp',
  component: () => import('@/pages/Documentacion/CrearDocOtp.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/document/reporte',
  name: 'documentacion-reporte',
  component: () => import('@/pages/Documentacion/ReporteDoc.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/document/creditos',
  name: 'documentacion-creditos',
  component: () => import('@/pages/Documentacion/Creditos.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/company/:companyId/mailing_sender',
  name: 'mailing_sender',
  component: () => import('@/pages/Companies/MailingSender.vue'),
  meta: { requiresAuth: true, requiresServices: [4] }
},
{
  path: '/company/:companyId/whatsapp_sources',
  name: '/whatsapp-sources',
  component: () => import('@/pages/Companies/WhatsappSources.vue'),
  meta: { requiresAuth: true, requiresServices: [3] }
},
{
  path: '/management/:user_chat_rol/chat/workgroup/:workgroup_id/:agent_name/:supervised_agent_id',
  component: () => import('@/pages/Chat/ChatApp.vue'),
  meta: { requiresAuth: true, requiresServices: [5] },
  children: [
    {
      path: '',
      name: 'workgroup-supervisor-chat-general',
      components: {
        default: () => import('@/pages/Chat/InitChat.vue'),
        drawer: () => import('@/pages/Chat/pages/ticketsDrawer.vue')
      },
      exact: true,
      meta: { requiresAuth: true, requiresServices: [5] }
    }, 
    {
      path: 'ticket/:ticket_id',
      name: 'workgroup-supervisor-chat-channel',
      components: {
        default: () => import('@/pages/Chat/pages/ChatTicketPage.vue'),
        drawer: () => import('@/pages/Chat/pages/ticketsDrawer.vue')
      },
      meta: { requiresAuth: true, requiresServices: [5] }
    },
    {
      path: 'kanban',
      name: 'workgroup-supervisor-chat-kanban',
      component: () => import('@/pages/Chat/KanbanView.vue'),
      meta: { requiresAuth: true, requiresServices: [5] }
    },
  ]
},
{
  path: '/:user_chat_rol/tools/chat',
  component: () => import('@/pages/Chat/ChatApp.vue'),
  meta: { requiresAuth: true, requiresServices: [5] },
  children: [
    {
      path: '',
      components:
      {
        default: () => import('@/pages/Chat/InitChat.vue'),
        drawer: () => import('@/pages/Chat/pages/ticketsDrawer.vue')
      },
      name:'workgroup-agent-chat-general',
      meta: { requiresAuth: true, requiresServices: [5] }
    }, 
    {
      path: 'ticket/:ticket_id',
      name: 'workgroup-agent-chat-channel',
      components:{ 
        default: () => import('@/pages/Chat/pages/ChatTicketPage.vue'),
        drawer: () => import('@/pages/Chat/pages/ticketsDrawer.vue')

      },
      meta: { requiresAuth: true, requiresServices: [5] }
    },
    {
      path: 'kanban',
      name: 'workgroup-agent-chat-kanban',
      component: () => import('@/pages/Chat/KanbanView.vue'),
      meta: { requiresAuth: true, requiresServices: [5] }
    },
  ]
}
]
